<li
  class="med-multiselect-item"
  [attr.tabindex]="disabled || option.disabled ? null : '0'"
  [class.disabled]="disabled || option.disabled"
  (keydown)="onKeydown.emit($event)"
  (click)="onOptionClick($event)"
>
  <div
    class="med-multiselect-item__box"
    [class.disabled]="disabled || option.disabled"
  >
    <ng-container *ngIf="selected">
      <med-icon-check
        *ngIf="!checkIconTemplate"
        size="16"
      ></med-icon-check>

      <span
        *ngIf="checkIconTemplate"
        class="p-checkbox-icon"
      >
        <ng-template *ngTemplateOutlet="checkIconTemplate"></ng-template>
      </span>
    </ng-container>
  </div>

  <span
    *ngIf="!template"
    class="med-multiselect-item__label"
  >
    {{ option.label }}
  </span>

  <ng-container *ngIf="template">
    <ng-template *ngTemplateOutlet="template; context: { $implicit: option }"></ng-template>
  </ng-container>
</li>
